export const ERROR_MESSAGES = {
	FORTNOX: {
		COULD_NOT_LOGIN: "Kan inte logga in, access-token eller client-secret saknas.",
		MISSING_REFRESH_TOKEN: "Fortnox: Missing refresh token",
	},
};
